import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Urunler from "../pages/urunler/page";
import Hali from "../pages/hali/page";
import EvTekstili from "../pages/ev-tekstili/page";
import Hakkimizda from "../pages/hakkimizda/page";
import Iletisim from "../pages/iletisim/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/urunler",
    element: <Urunler />,
  },
  {
    path: "/hali",
    element: <Hali />,
  },
  {
    path: "/ev-tekstili",
    element: <EvTekstili />,
  },
  {
    path: "/hakkimizda",
    element: <Hakkimizda />,
  },
  {
    path: "/iletisim",
    element: <Iletisim />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
